import React from 'react';

const ButtonBase = ({ callFunction, buttonName, enabled, callClick, css, etiqueta, icons }) => {
  const isEnabled = (enable) => {
    let isInputEnabled;
    switch (enable) {
      case true:
        isInputEnabled = '';
        break;
      case false:
        isInputEnabled = 'disabled';
        break;
      default:
        isInputEnabled = ''
    }
    return isInputEnabled;
  }

  return (
    <button
      name={buttonName}
      className={css ? `ButtonBase ${css}` : 'ButtonBase'}
      type="button"
      onSubmit={callFunction}
      onClick={callClick}
      disabled={isEnabled(enabled)}
    >
      {' '}
      {icons && <img src={icons} className="iconButtonBase" alt="svg" />}
      {etiqueta}
      {' '}
    </button>
  );
};

export default ButtonBase;
